import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquarePlus, faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddVacunas = () => {
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [Vacunas, setVacunas] = useState([]);
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
  const [selectedVacuna, setSelectedVacuna] = useState(null);

  useEffect(() => {
    getVacunas();
  }, []);

  const editFields = [
    
    { name: "Nombre", label: "Nombre Vacuna", type: "text", required: true },
    { name: "Descripcion", label: "Descripción Vacuna", type: "text", required: false }
  ];

  const getVacunas = async () => {
    try {
      const response = await api.get(`/vacunas`);
      setVacunas(response.data);
    } catch (error) {
      console.error("Error al obtener vacunas:", error);
    }
  };

  const createVacuna = async (e) => {
    e.preventDefault();

    const existe = Vacunas.some(
      (v) => normalizar(v.Nombre) === normalizar(Nombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe una vacuna con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      // Siempre crear activa (Estado = 1)
      await api.post(`/vacunas`, { Nombre, Descripcion });
      getVacunas();
      setNombre("");
      setDescripcion("");
      setFiltroEstado("activas"); // Mostrar en pestaña activas
      Swal.fire({
        icon: "success",
        title: "Vacuna guardada",
        text: "La vacuna fue guardada exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un problema al guardar la vacuna.",
      });
    }
  };

  const handleEditVacuna = async (values) => {
    try {
     await api.put(`/vacunas/${values.IdVacunacion}`, {
        Nombre: values.Nombre,
        Descripcion: values.Descripcion
      });
      Swal.fire({
        icon: "success",
        title: "Vacuna actualizada",
        showConfirmButton: false,
        timer: 1500,
      });
      setSelectedVacuna(null);
      getVacunas();
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar la vacuna.",
      });
    }
  };
const cambiarEstado = async (IdVacunacion) => {
  try {
    const vacunaActual = Vacunas.find(v => v.IdVacunacion === IdVacunacion);
    const nuevoEstado = vacunaActual.Estado === 1 ? 0 : 1;
    const estadoTexto = nuevoEstado === 1 ? "activada" : "desactivada";

    // Confirmación antes de desactivar
    if (nuevoEstado === 0) {
      const result = await Swal.fire({
        icon: "warning",
        title: "¿Desactivar vacuna?",
        text: "Si está siendo utilizada, no podrá desactivarse.",
        showCancelButton: true,
        confirmButtonText: "Sí, desactivar",
        cancelButtonText: "Cancelar",
      });
      if (!result.isConfirmed) return;
    }

    // Llamada a la API
    await api.patch(`/vacunas/${IdVacunacion}/estado`);

    // Actualizar estado localmente
    setVacunas(prev =>
      prev.map(v => v.IdVacunacion === IdVacunacion ? { ...v, Estado: nuevoEstado } : v)
    );

    Swal.fire({
      icon: "success",
      title: `Vacuna ${estadoTexto}`,
      text: `La vacuna fue ${estadoTexto} correctamente.`,
      timer: 1500,
      showConfirmButton: false,
    });

  } catch (error) {
    console.error("Error al cambiar estado:", error);

    // Caso 409: vacuna en uso
    if (error.response?.status === 409) {
      Swal.fire({
        icon: "warning",
        title: "No permitido",
        text: error.response.data.msg,
      });
      return;
    }

    // Error general
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Ocurrió un error al cambiar el estado de la vacuna.",
    });
  }
};
  const filtrarVacunas = () => {
    if (filtroEstado === "activas") return Vacunas.filter(v => v.Estado === 1);
    if (filtroEstado === "inactivas") return Vacunas.filter(v => v.Estado === 0);
    return Vacunas;
  };

  const columnas = [
    {
      name: "Nombre",
      selector: row => row.Nombre,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Descripción",
      cell: row => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({
            ...mostrarDescripcion,
            [row.IdVacunacion]: !mostrarDescripcion[row.IdVacunacion]
          });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 40;

        return (
          <div style={{ display: "flex", alignItems: "center", width: "30vw", overflow: "hidden" }}>
            <div style={{ flex: 1 }}>
              {!mostrarDescripcion[row.IdVacunacion]
                ? descripcion.length > 40 ? descripcion.substring(0, 40) + "..." : descripcion
                : descripcion
              }
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={toggleDescripcion}>
                {mostrarDescripcion[row.IdVacunacion] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: "30vw",
    },
    {
      cell: row => (
        <button className="button is-small is-info" title="Editar" onClick={() => setSelectedVacuna(row)}>
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
    {
      cell: row => row.Estado === 1
        ? <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdVacunacion)} />
        : <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdVacunacion)} />,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
  ];

  const paginationOptionsES = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
  };

  return (
    <div className="columns mt-5 is-centered">
      <div>
        <div className="notification is-primary">
          <strong>Agregar Vacuna</strong>
        </div>

        <form onSubmit={createVacuna}>
          <div className="field">
            <label className="label required">Nombre Vacuna</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre"
                required
              />
            </div>
          </div>

          <div className="field">
            <label className="label">Descripción Vacuna</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                placeholder="Descripción"
              />
            </div>
          </div>

          <div className="field mt-3">
            <button type="submit" className="button is-success">Guardar</button>
          </div>
        </form>

        <div style={{ display: 'flex', gap: '10px', margin: '1rem 0' }}>
          {["todas", "activas", "inactivas"].map(estado => (
            <button
              key={estado}
              type="button"
              onClick={() => setFiltroEstado(estado)}
              className={`button is-small ${filtroEstado===estado?'is-primary':'is-light'}`}
            >
              {estado.charAt(0).toUpperCase() + estado.slice(1)}
            </button>
          ))}
        </div>

        <DataTable
          pagination
          paginationComponentOptions={paginationOptionsES}
          columns={columnas}
          data={filtrarVacunas()}
        />

        {selectedVacuna && (
          <EditModal
            fields={editFields}
            initialValues={selectedVacuna}
            onSubmit={handleEditVacuna}
            title="Editar Vacuna"
            onClose={() => setSelectedVacuna(null)}
          />
        )}
      </div>
    </div>
  );
};

export default AddVacunas;
